/// <amd-module name="Repos/Views/CommitHub/Components/CommitDetailsExtensions" />
import * as React from "react";
import { IRegionComponentProperties, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { ICommitViewService } from "../CommitViewService";

export class CommitDetailsExtensions extends VssComponent {
    public render() {
        const commitViewService = this.context.pageContext.getService<ICommitViewService>("ICommitViewService");

        return (
            <WrappedComponent<IRegionComponentProperties>
                dependencies={["ms.vss-code-web.commit-details-extensions"]}
                wrappedType="ms.vss-web.region"
                wrappedProps={{
                    childComponentProperties: {
                        commitId: commitViewService.getCommitId(),
                        repository: commitViewService.getRepository()
                    },
                    className: "rhythm-vertical-16",
                    componentRegion: "commitDetailsExtensions"
                }}
            />
        );
    }
}
